import React, {Component} from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import StageEditor from '../stage-editor/stage-editor';
import ScreenEmulator from '../screen-emulator/screen-emulator';
import '../common/react-tabs.css';

/** @class EntryEditor
  * A component for editing a virtual expo's entry
  */
export default class EntryEditor extends Component {
  /** @method render
    * Renders the component.
    */
  render() {
    return (
      <Tabs>
        <TabList>
          <Tab>Stage</Tab>
          <Tab>Preview</Tab>
        </TabList>
        <TabPanel>
          <StageEditor dataURL={`${this.props.dataURL}/stage`} />
        </TabPanel>
        <TabPanel>
          <ScreenEmulator src={'/preview/#' + this.props.dataURL} />
        </TabPanel>
      </Tabs>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/entry-editor/entry-editor.js